import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Form, Row, Col, Button } from "reactstrap";

import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import { Block, BlockHead, BlockHeadContent, BlockTitle, PreviewAltCard } from "../../components/Component";

import MyInput from "../../MyComp/UI/form/MyInput";
import MyMobile from "../../MyComp/UI/form/MyMobile";
import MyEmail from "../../MyComp/UI/form/MyEmail";
import MySelect from "../../MyComp/UI/form/MySelect";
import MyDate from "../../MyComp/UI/form/MyDate";
import MyTextArea from "../../MyComp/UI/form/MyTextArea";
import Status from "../../MyComp/UI/form/Status";
import ImageUpload from "../../MyComp/UI/form/ImageUpload";

const Advertisements = () => {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    clearErrors,
    setError,
    getValues,
    formState: { errors },
  } = useForm();

  const [loading, setLoading] = useState(false);

  const genderOption = [
    { value: "male", label: "Male" },
    { value: "female", label: "Female" },
  ];

  const onFormSubmit = (formData) => {
    console.log("Form Data 👉", formData);
  };

  return (
    <>
      <Head title="Advertisements" />
      <Content>
        <BlockHead size="sm">
          <BlockHeadContent>
            <BlockTitle tag="h3">Advertisement</BlockTitle>
          </BlockHeadContent>
        </BlockHead>

        <Block>
          <PreviewAltCard>
            <Form onSubmit={handleSubmit(onFormSubmit)}>
              <Row>
                <Col md="4">           
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="App button text"
                    name="app_button_text"
                    placeholder="Enter app button text"
                    required
                  />
                </Col>
                  <Col md="4">
                  <MyDate
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="Visible from"
                    name="visible_from"
                    placeholder="Select visible from date"
                    required
                  />
                </Col>
                  <Col md="4">
                  <MyDate
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="Visible to"
                    name="visible_to"
                    placeholder="Select visible to date"
                    required
                  />
                </Col>
                 <Col md="12">
                  <MyTextArea
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="Content"
                    name="content"
                    placeholder="Enter content"
                    required
                  />
                </Col>
                <Col md="2">
                  <Button color="primary" type="submit" disabled={loading} style={{ marginTop: "30px" }}>
                    Submit
                  </Button>
                </Col>
              </Row>
            </Form>
          </PreviewAltCard>
        </Block>
      </Content>
    </>
  );
};

export default Advertisements;